import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth"; // Import listener autentikasi
import { Link } from "react-router-dom";
import { FaClock, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { toast } from "react-toastify";

const DepositStatus = () => {
    const [deposits, setDeposits] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Menggunakan listener onAuthStateChanged
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchDeposits(user.uid); // Ambil data deposit jika pengguna sudah login
            } else {
                toast.error("Anda harus login untuk melihat status deposit.");
                setIsLoading(false);
            }
        });

        // Membersihkan listener saat komponen dilepas
        return () => unsubscribe();
    }, []);

    // Fungsi mengambil data deposit dari database
    const fetchDeposits = (uid) => {
        const db = getDatabase();
        const depositRef = ref(db, `deposits/${uid}`);

        onValue(
            depositRef,
            (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const depositList = Object.keys(data).map((key) => ({
                        id: key,
                        ...data[key]
                    }));
                    setDeposits(depositList.reverse());
                } else {
                    setDeposits([]);
                }
                setIsLoading(false);
            },
            (error) => {
                console.error("Error mengambil data deposit:", error);
                toast.error("Gagal mengambil data deposit.");
                setIsLoading(false);
            }
        );
    };

    // Format tanggal dari timestamp
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    return (
        <div className="container mx-auto p-4">
            <div role="alert" className="alert">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    className="stroke-info h-6 w-6 shrink-0"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                </svg>
                <p>
                    Jika saldo tidak masuk, silahkan{" "}
                    <Link
                        className="text-red-500"
                        to="https://wa.me/6282241515135"
                    >
                        chat admin disini
                    </Link>
                </p>
            </div>
            <h1 className="text-2xl font-bold mb-4">Cek Status Deposit</h1>

            {isLoading ? (
                <p>Memuat data deposit...</p>
            ) : deposits.length === 0 ? (
                <p>Tidak ada data deposit.</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="table w-full border">
                        <thead>
                            <tr className="bg-gray-100">
                                <th>ID</th>
                                <th>Tanggal</th>
                                <th>Jumlah (Rp)</th>
                                <th>Metode</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {deposits.map((deposit) => (
                                <tr key={deposit.id} className="border-b">
                                    <td>{deposit.id}</td>
                                    <td>{formatDate(deposit.timestamp)}</td>
                                    <td>
                                        Rp{" "}
                                        {parseFloat(
                                            deposit.amount
                                        ).toLocaleString("id-ID")}
                                    </td>
                                    <td>{deposit.method.toUpperCase()}</td>
                                    <td>
                                        {deposit.status === "pending" ? (
                                            <span className="flex items-center text-yellow-500">
                                                <FaClock className="mr-1" />
                                                Pending
                                            </span>
                                        ) : deposit.status === "success" ? (
                                            <span className="flex items-center text-green-500">
                                                <FaCheckCircle className="mr-1" />
                                                Success
                                            </span>
                                        ) : (
                                            <span className="flex items-center text-red-500">
                                                <FaTimesCircle className="mr-1" />
                                                Ditolak
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default DepositStatus;
